<ng-container [formGroup]="form">
    <mat-form-field apperance="fill" [ngClass]="class" class="w-full">
        <mat-label> {{label | transloco}}</mat-label>
        <mat-select [formControlName]="controlName" placeholder="{{label |transloco}}" [multiple]="multiple" 
            [disabled]="disabled" [compareWith]="compareObjects">

            <mat-option *ngFor="let record of records" [value]="valueSelector?record[valueSelector]:record" (click)="selectionChange.emit(record)" >
                <ng-container *ngIf="localized">
                    {{record.name |localized}}

                </ng-container>
                <ng-container *ngIf="!localized">
                    {{record.name }}

                </ng-container>
            </mat-option>
        </mat-select>
        <mat-error *ngIf="form.get(controlName)?.hasError('required')"> {{label|transloco}} {{'Is Required' |transloco}}
        </mat-error>
    </mat-form-field>
</ng-container>
